import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";

import { integrationMaxWidth } from "app/pages/sales-intelligence/pages/manage-export/style";
import HelpButton from "app/pages/sales-intelligence/sub-modules/account-overview/shared/components/HelpButton/HelpButton";

export const StyledManagementWrapper = styled.div`
    background-color: ${colorsPalettes.bluegrey[100]};
`;

export const StyledManagementTabsContainer = styled(FlexColumn)`
    margin: 0 auto;
    width: 100%;
    align-self: center;
    ${integrationMaxWidth}
`;

export const StyledManagementHeader = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 32px;
    margin-bottom: 4px;

    ${setFontVariant("h4", colorsPalettes.carbon[400])};
    line-height: 32px;
`;

export const StyledManagementTitle = styled.div`
    display: flex;
    ${setFontVariant("h4", colorsPalettes.carbon[400])};
    line-height: 32px;
`;

export const StyledHeader = styled(FlexColumn)`
    width: 100%;
    margin-bottom: 24px;
`;

export const StyledBreadcrumbsContainer = styled.div`
    margin-bottom: 24px;
`;

export const StyledHelpButton = styled(HelpButton)`
    display: flex;
`;
